/* eslint-disable */
import ggAddress from 'ggApp/modules/address';
import ggOrder from 'ggApp/modules/order';
import { LayoutComponent_LocalLoader } from 'ggApp/modules/layout';
import { replaceTo } from 'ggApp/modules/router/actions';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';


@connect(
    createStructuredSelector({
        order: ggOrder.selectors.orderActive,
        addressListFetching: ggAddress.selectors.addressListFetching,
        addressListForCurrentCountry: ggAddress.selectors.addressListForCurrentCountry,
    }),
    dispatch => ({
        replaceTo: bindActionCreators(replaceTo, dispatch),
    }),
)
export default class CheckoutAddressWrap extends Component {
    componentWillReceiveProps(nextProps) {
        const {
            addressListForCurrentCountry,
            addressListFetching,
        } = nextProps;
        if (
            !addressListFetching
      && addressListForCurrentCountry.length === 0
        ) {
            nextProps.replaceTo('/checkout/address/create');
        }
    }

    render() {
        const
            { addressListFetching } = this.props;

        return (
            <LayoutComponent_LocalLoader active={addressListFetching}>
                {this.props.children}
            </LayoutComponent_LocalLoader>
        );
    }
}
